export default "__VITE_ASSET__DZXnU_KH__"